<template>
  <ui-card class="card-event">
    <ui-image :src="cover" cover class="card-event-image" @click="go">
      <div class="card-title">
        <h3>
          <ui-icon name="icon-lock" v-if="event.passwordProtection" :title="$t('passwordProtection')"></ui-icon>{{ event.title }}
        </h3>
        <p v-if="event.intro">{{ event.intro }}</p>
      </div>
    </ui-image>
    <ui-avatar :url="event.userInfo.avatar" :username="event.userInfo.username">{{$d(new Date(event.created))}}</ui-avatar>
    <p>
      <router-link v-if="event.isAuthor" :to="'/event/setting/'+event.id">settings</router-link>
      <span class="muted" v-if="event.isAuthor">|</span>
      <router-link v-if="event.isAuthor" :to="'/event/edit/'+event.id">edit</router-link>
    </p>
  </ui-card>
</template>
<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixin/role.js'

export default {
  name: "CardEvent",
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      showIntro: false
    };
  },
  mixins: [userRole],
  components: {

  },
  computed: {
    cover() {
      return this.event.cover[0]
    },
    ...mapGetters(['authInfo'])
  },
  methods: {
    go() {
      this.$router.push("/e/" + this.event.code);
    }
  },
  mounted() {

  }
};

</script>
